import React from 'react';
import classnames from 'classnames';
import { UIButtonVariant, UISize } from '../types';
import bemBlock from '@gik/core/utils/bemBlock';
import Link from '@/components/Link';
import { Button } from '..';

export interface BreadCrumbItemsType {
  label: string;
  url?: string;
}

export interface IBreadCrumbsProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Button variant to use
   */
  variant?: UIButtonVariant;

  /**
   * Size the button on a fixed scale
   */
  size?: UISize;

  items?: BreadCrumbItemsType[];

  /**
   * Render a slash after the last breadcrumb
   */
  trailingSlash?: boolean;
}

/**
 * BreadCrumbs component
 */
export default function BreadCrumbs({
  variant,
  size,
  items,
  trailingSlash = false,
}: IBreadCrumbsProps): React.ReactElement {
  const bem = bemBlock('breadcrumbs');
  const blockClasses = classnames([
    bem(),
    { [bem(null, [variant])]: variant },
    { [bem(null, ['size-' + size])]: size },
    { [bem(null, ['trailing-slash'])]: trailingSlash },
  ]);

  return (
    <div className={blockClasses}>
      <ul>
        {items.map((item, index) => {
          return (
            <li key={index}>
              {index < items.length - 1 || trailingSlash ? (
                <Link href={item.url}>
                  <Button variant="primary-link">{item.label}</Button>
                </Link>
              ) : (
                item.label
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
